import React from "react";
import metafizikBoyutuLarge from '../../../assets/books/kapaklar/allahin-metafizik-boyutu_600.jpg';
import metafizikBoyutuMini from '../../../assets/books/kapaklar/allahin-metafizik-boyutu-300.jpg';
export const MetafizikBoyutuDescription = (props: any) => {
    return (
        <div className="summary-description">

            <div className="book-image">
                <img
                    srcSet={`${metafizikBoyutuMini} 300w, ${metafizikBoyutuLarge} 600w`}
                    sizes={"(max-width: 600px) 300px,  600px"}
                    src={metafizikBoyutuLarge}
                    alt="Allah'ın Varlıklarının Metafizik Boyutu" />
            </div>
            <p>
                Hz. İnsan akıl aparatıyla anlar, vicdanla tartar ve karar verir, hayal ile planlar
                hafıza ile bilgi depolar, kendi alemindeki metafizik boyutunu sezer, kalp ile sever.
            </p>
            <p>
                Madde ve fizik ötesi varlıkların mevcudiyetiyle alakalı deliller çeşit çeşittir.
                Bunlardan kimisi peygamberlere, kimisi velilere, kimisi de üniversitelerde araştırma
                yapan araştırmacılara aittir. Ancak bütün bu müşahitlerin birleştikleri ortak bir nokta vardır.
                O da maddenin ötesinde, ne madde ne de fizikle izahı mümkün olmayan yaratıkların mevcudiyetidir.<br />
            </p>
            <p>
                Madde asıl değildir. O ruh ile kaimdir.
                <ul className="maddeler">
                    <li>Artık sen de Rabbinle tanış buyurdu.</li>
                    <li>Nasıl dedim. Rabbimle nasıl taşırım? Böyle bir tanışma var mı?</li>
                    <li>Evet var diye buyruldu.</li>
                    <li>Her kul ömrünün bir kısmında bir şekilde Yaradan'la tanışmak zorundadır.</li>
                    <li>Elhamdülillah. Allah'a şükürler olsun. Bu çok önemli bir şeydir.</li>
                    <li>Ama böyle bir şey sufizm öğretisi üzerine olur. Devam etti.</li>
                    <li>
                        <p>
                            Zaten bir çok insan bu yüzden hayattayken "Rableriyle Tanışmadan" bu dünyadan ayrılır. Onlar, Rabbin kullarına
                            sunduğu tanışma teklifini ya reddederler; ya bilmezler, ya da duymazlar. Bir şekilde bu tanışmadan, bu lütuftan,
                            iltifattan mahrum kalırlar. Gökler, güneş, ay, yıldızlar; tüm güneş sistemi, gezegenler, galaksiler, yerler,
                            bitkiler, hayvanlar, dağlar, taşlar, denizler, yerle gök arasındakiler... Tüm kâinat yaratılmıştı. Yaratılan her şey,
                            Rabbin vahyi ile görevlerini yapıyordu. Ağaçlar, meyve veriyor... Hayvanlar ürüyor... Güneş doğup batıyor... Ay şavkını dünyaya vuruyor...
                            Yıldızlar yanıp sönüyordu. Bütün varlıklar Allah'ın istediği şekilde kendi karşısında kayıtsız, şartsız boyun eğip secde ediyordu. Tıpkı hala ettikleri gibi.

                        </p>
                        <p>
                            Yaratılan hiçbir varlık bu secdeden bi an olsun kalkamz, Allah'ın onlara uygun gördüğü
                            nizamdan bir an olsun şaşmazdı. Vahyin dışına çıkıp zerre kadar itaatsizlik etme şansları yoktu.
                        </p>
                        <p>
                            Bu yüce Yaradan'ın zerre şaşmaz nizamıdır ve nizamıydı.
                        </p>
                        <p>KİM, bu kusursuz yaratılışı görüp tefekkür edecek, duyacak, bilecek, hissedecekti?
                            Bütün bu ninetlerden kim okur, faydalanıp Yaradan'ına şuurlu, biliçli bir şekilde hamd edecek,
                            şükredecek, secde edip boyun eğecekti?
                        </p>
                        <p>Yüce Yaradan en büyük AYETULLAH olan HZ.İnsanı yarattı.</p>
                    </li>
                </ul>
            </p>
        </div>
    )
}
export const MetafizikBoyutuSummaryDescription = (props: any) => {
    return (
        <p>
            Hz. İnsan akıl aparatıyla anlar, vicdanla tartar ve karar verir, hayal ile planlar
            hafıza ile bilgi depolar, kendi alemindeki metafizik boyutunu sezer, kalp ile sever.
            Madde ve fizik ötesi varlıkların mevcudiyetiyle alakalı deliller çeşit çeşittir.
            Bunlardan kimisi peygamberlere, kimisi velilere, kimisi de üniversitelerde araştırma
            yapan araştırmacılara aittir. Ancak bütün bu müşahitlerin birleştikleri ortak bir nokta vardır.
            O da maddenin ötesinde, ne madde ne de fizikle izahı mümkün olmayan yaratıkların mevcudiyetidir.<br />
        </p>
    )
}
